import { render, staticRenderFns } from "./r-currency-group-dropdown.vue?vue&type=template&id=3f5ee062"
import script from "./r-currency-group-dropdown.vue?vue&type=script&lang=js"
export * from "./r-currency-group-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5ee062')) {
      api.createRecord('3f5ee062', component.options)
    } else {
      api.reload('3f5ee062', component.options)
    }
    module.hot.accept("./r-currency-group-dropdown.vue?vue&type=template&id=3f5ee062", function () {
      api.rerender('3f5ee062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency-group/r-currency-group-dropdown.vue"
export default component.exports